const routes = {
  Home: '/',

  Cart: '/cart',
  Tracking: '/tracking',
  TrackingShow: '/tracking/:id',
  OrdersHistory: '/account/orders-history',
  OrdersHistoryShow: '/account/orders-history/:id',

  Contact: '/contact',
  Account: '/account',
  AccountProfile: '/account/profile',
  AccountSubscription: '/account/subscriptions',
  AccountAddressBook: '/account/address-book',
  AccountWallet: '/account/wallet',
  AccountLegacyOrders: '/account/orders-history',
  AccountPasswordReset: '/account/password-reset/:token',

  CartEdit: '/orders-history/:id',

  Login: '/login',
  Register: '/register',
  ForgetPassword: '/reset-password',
  ChooseCountry: '/choose-country',

  Blackfriday: '/black-friday',
  CyberMonday: '/cyber-monday',
  EndOfYear: '/new-year-sale',
  Business: '/business-plans',
  Pricing: '/pricing',
  Faq: '/faq',
  Stores: '/stores',
  TermsAndConditions: '/terms-and-conditions',
  ProhibitedItems: '/prohibited-items',
  LynksVsEdfa3ly: '/lynks-vs-edfa3ly',
  HowItWorks: '/how-it-works',

  LiteCheckout: '/checkout',
  Checkout: '/checkout/:type/:id',
  typeOnlyCheckout: '/checkout/:type/',
  ThankYou: '/checkout/:type/thank_you',

  HealthCheck: '/health_check',
  Promotions: '/promotions',
  PromotionPage: '/promotions/:id',

  CashbackPage: '/cashback',
};

export default routes;



// WEBPACK FOOTER //
// ./app/config/routes.js